import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    gap: ({ spacing }) => spacing(0.5),
  },
} satisfies Record<string, SxProps<Theme>>
